import Image from "next/image";
import { SimpleGrid, Box } from "@chakra-ui/react";
import { ADVANTAGES_IMAGES } from "./constants";

const AdvantagesComp = () => {
  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: 6, md: 8 }}>
      {ADVANTAGES_IMAGES.map((item, index) => (
        <Box
          key={index}
          transition="transform 0.3s ease"
          _hover={{ transform: "scale(1.05)" }}
        >
          <Image
            src={item}
            alt="EDR"
            width={300}
            height={300}
            quality={100}
            style={{
              width: item.width,
              height: item.height,
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default AdvantagesComp;
